import React, { useState } from "react";
import {
  XYPlot,
  LineSeries,
  XAxis,
  YAxis,
  HorizontalGridLines,
  VerticalGridLines,
  Crosshair,
  GradientDefs,
} from "react-vis";

export default function SignalStrength({ data }) {
  const [crosshairValues, setCrosshairValues] = useState([]);

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString("pt-BR", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  return (
    <div>
      <div>
        <XYPlot
          width={1020}
          height={300}
          margin={{ left: 60, right: 20, top: 20, bottom: 60 }}
          yDomain={[-100, 0]}
          onMouseLeave={() => setCrosshairValues([])}
        >
          <HorizontalGridLines />
          <VerticalGridLines />

          <XAxis
            tickFormat={formatTime}
            tickTotal={6}
            style={{
              title: { fontSize: "14px", fill: "#374151" },
            }}
          />

          <YAxis
            title="Intensidade do Sinal (dBm)"
            tickValues={[-100, -75, -50, -25, 0]}
          />

          <GradientDefs>
            <linearGradient
              id="gradient"
              x1="0%"
              x2="0%"
              y1="100%"
              y2="0%"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0%" stopColor="#ed1b20" />
              <stop offset="40%" stopColor="#ed1b20" />
              <stop offset="45%" stopColor="#f2671e" />
              <stop offset="53%" stopColor="#e3d10c" />
              <stop offset="65%" stopColor="#89c53e" />
              <stop offset="100%" stopColor="#0fa949" />
            </linearGradient>
          </GradientDefs>

          <LineSeries
            data={data}
            color={"url(#gradient)"}
            strokeWidth={2}
            onNearestX={(value) => setCrosshairValues([value])}
          />

          {crosshairValues.length > 0 && (
            <Crosshair values={crosshairValues}>
              <div style={{ color: "gray", width: "50px" }}>
                <div>
                  <b>Horário:</b> {formatTime(crosshairValues[0].x)}
                </div>
                <div>
                  <b>Sinal:</b> : {crosshairValues[0].y} dBm
                </div>
              </div>
            </Crosshair>
          )}
        </XYPlot>
      </div>
    </div>
  );
}
